import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const ledgerSummaryURL = "api/v1/account-app/account-reports-summary/account-ledger";
const ledgerDetailURL = "api/v1/account-app/accounting-reports/account-ledger";

//for sumamry data
export const getSummaryLedgerReportData = ({ rowsPerPage, search, sortOrder, pageNo, group, account, cashAccount }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${ledgerSummaryURL}/list?${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}&account_group=${group}&is_cash_account=${cashAccount}&id=${account}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

export const getSummaryPrevious = (previous) => axiosInstance.get(previous);

export const getSummaryNext = (next) => axiosInstance.get(next);

export const getSummaryParticularPage = ({ number, rowsPerPage, search, group, account, cashAccount }) =>
  axiosInstance.get(
    `${ledgerSummaryURL}/list?${paginationQueryParams(
      rowsPerPage,
      search,
      "",
      number
    )}&account_group=${group}&is_cash_account=${cashAccount}&id=${account}`
  );

//for details
export const getDetailLedgerReportData = ({ rowsPerPage, search, sortOrder, pageNo, group, account, cashAccount }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${ledgerDetailURL}/list?${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}&account_group=${group}&is_cash_account=${cashAccount}&id=${account}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

export const getDetailPrevious = (previous) => axiosInstance.get(previous);

export const getDetailNext = (next) => axiosInstance.get(next);

export const getDetailParticularPage = ({ number, rowsPerPage, search, group, account, cashAccount }) =>
  axiosInstance.get(
    `${ledgerDetailURL}/list?${paginationQueryParams(
      rowsPerPage,
      search,
      "",
      number
    )}&account_group=${group}&is_cash_account=${cashAccount}&id=${account}`
  );
